export class DateHelpers {

    static toHttpParameter(date: Date): string {
        if (!date)
            return '';

        const day   = date.getDate()     ;
        const month = date.getMonth() + 1;
        const year  = date.getFullYear() ;

        return year + (month < 10 ? "0" : "") + month + (day < 10 ? "0" : "") + day;
    }
}
